import { BooleanInput } from '@angular/cdk/coercion';
import {
  ChangeDetectionStrategy,
  Component,
  booleanAttribute,
  input,
  output,
  signal,
} from '@angular/core';
import { Button } from '../../button/button.component';
import { Wizard } from '../wizard.component';

@Component({
  selector: 'procure-wizard-actions',
  templateUrl: './wizard-actions.component.html',
  styleUrl: './wizard-actions.component.scss',
  imports: [Button],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WizardActions {
  readonly wizard = input.required<Wizard>();
  readonly backLabel = input('Back');
  readonly nextLabel = input('Next');
  readonly finishLabel = input('Finish');
  readonly finishLoading = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });
  readonly disableWhenInvalid = input<boolean, BooleanInput>(true, {
    transform: booleanAttribute,
  });
  readonly beforeNext = input<() => boolean | Promise<boolean>>();

  readonly finish = output<void>();

  readonly isAdvancing = signal(false);

  async goToNext(): Promise<void> {
    const wizard = this.wizard();

    if (!wizard.canProceed()) {
      wizard.revealErrors();

      return;
    }

    const beforeNext = this.beforeNext();

    if (beforeNext) {
      const startIndex = wizard.selectedIndex;

      this.isAdvancing.set(true);

      try {
        if (!(await beforeNext()) || wizard.selectedIndex !== startIndex) {
          return;
        }
      } finally {
        this.isAdvancing.set(false);
      }
    }

    wizard.next();
  }

  complete(): void {
    const wizard = this.wizard();

    if (!wizard.canProceed()) {
      wizard.revealErrors();

      return;
    }

    this.finish.emit();
  }
}
